import { Box, Stack } from '@mui/material';

// Bloco cinza pulsando enquanto o conteúdo carrega (keyframes konq-pulse no GlobalStyle).
export function SkeletonBlock({ height = 56, width = '100%', sx = {} }) {
  return (
    <Box
      sx={{
        height,
        width,
        borderRadius: 2,
        bgcolor: 'grey.200',
        animation: 'konq-pulse 1.5s ease-in-out infinite',
        ...sx,
      }}
    />
  );
}

export default function LoadingSkeleton({ rows = 3, height = 56, spacing = 2 }) {
  return (
    <Stack spacing={spacing}>
      {Array.from({ length: rows }, (_, i) => (
        <SkeletonBlock key={i} height={height} />
      ))}
    </Stack>
  );
}
